import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');


export class LayerMenuActiveItemComponent extends HTMLElement{
    constructor(){
        super();

        let label = this.getAttribute('data-label')
        let id = this.getAttribute('data-id')
        const type = this.getAttribute('data-type')
        let checked = this.getAttribute('data-checked')
        if(checked === "true") {
            checked = "1"
        } else {
            checked = ''
        }

        template.innerHTML = `

        <div class="card card-hover-secondary mb-2" title="${label}">
            <div class="card-header bg-lighter pt-1 pb-1 pl-2">
                <layer-menu-group-item data-label="${label}" data-checked="` + checked + `" data-type="` + type + `" data-bookmark-presentation-id="` + id + `"></layer-menu-group-item>
            </div>
        </div>
        `
        initWebComponent(this, template)
    }
}
